import axios from 'axios'
import _ from 'lodash'
import { getSavedState, saveState } from '@state/helpers'

export const state = {
  cached: [],
  cart: getSavedState('customer.cart'),
}

export const getters = {
  // Whether the user has a product in cart
  hasCartProduct(state) {
    return state.cart
  },
}

export const mutations = {
  CACHE_USER(state, newUser) {
    state.cached.push(newUser)
  },
  UPDATE_CART(state, cart) {
    state.cart = cart
    saveState('customer.cart', cart)
  },
  VALID_CART(state, validCart) {
    state.validCart = validCart
    saveState('customer.validCart', validCart)
  },
}

export const actions = {
  fetchUser({ commit, state, rootState }, { email }) {
    return axios.get(`/consumer-api/customer/v1/current`).then((response) => {
      const user = response.data
      commit('CACHE_USER', user)
      return user
    })
  },
  // Registers a new customer
  async register({ commit, dispatch, getters }, registrationData = {}) {
    const customer = await axios
      .post('/consumer-api/authenticate/register', registrationData)
      .then((response) => {
        const customer = response.data
        // this commits to auth, full path is required and root set to true in order to access different state object
        commit('auth/SET_CURRENT_USER', customer, { root: true })
        return customer
      })

    const user = await dispatch(
      'auth/logIn',
      { email: customer.email, password: registrationData.password },
      { root: true }
    )

    return user
  },

  // Registers buyback protection
  registerBuybackProtection({ commit, dispatch, getters }, buybackData = {}) {
    return axios
      .post('/consumer-api/buyback/v1', buybackData)
      .then((response) => {
        return ''
      })
      .catch((error) => {
        // Reject the promise is required to trigger error on response
        return Promise.reject(error.response.data.message)
      })
  },
  // Updates customer
  updateCustomer({ commit, rootState, dispatch, getters }, customerObj = {}) {
    // Merge the params sent with the logged in user data with the store copy
    let mergedCustomer = _.merge({}, rootState.auth.currentUser, customerObj)

    return axios
      .put(`/consumer-api/customer/v1`, mergedCustomer)
      .then((response) => {
        // Update the store with the new customer data
        commit('auth/SET_CURRENT_USER', mergedCustomer, { root: true })
        return customerObj
      })
      .catch((error) => {
        let errorMessage
        switch (error.response.status) {
          case 403:
            errorMessage = 'Please enter your current password'
            break
          case 409:
            errorMessage = 'An account already exists for this email address'
            break
          default:
            errorMessage = error.response.data.message
        }

        // Reject the promise is required to trigger error on response
        return Promise.reject(errorMessage)
      })
  },

  // send unlock account e-mail
  updateLockedAccountPassword({ commit, dispatch, getters }, email) {
    return axios
      .post(`/consumer-api/send-email/v1/updateLockedAccountPassword/${email}`)
      .then((response) => {
        return email
      })
      .catch((error) => {
        // Reject the promise is required to trigger error on response
        return Promise.reject(error.response.data.message)
      })
  },

  // Sends forgot password e-mail
  forgotPassword({ commit, dispatch, getters }, email) {
    return axios
      .post(`/consumer-api/send-email/v1/forgotPassword/${email}`)
      .then((response) => {
        return email
      })
      .catch((error) => {
        // Reject the promise is required to trigger error on response
        return Promise.reject(error.response.data.message)
      })
  },
  // Resets user password from e-mail with token
  resetPassword({ commit, dispatch, getters }, { password, email, token }) {
    return axios
      .post(`/consumer-api/authenticate/email-password-reset?token=${token}`, {
        email,
        password,
      })
      .then((response) => {
        return true
      })
      .catch((error) => {
        // Reject the promise is required to trigger error on response
        return Promise.reject(error.response.data.message)
      })
  },

  // Resets user password for locked account from e-mail with token
  resetLockedAccountPassword(
    { commit, dispatch, getters },
    { password, email, token }
  ) {
    return axios
      .post(
        `/consumer-api/authenticate/email-password-reset?token=${token}&accountunlock=y`,
        {
          email,
          password,
        }
      )
      .then((response) => {
        return true
      })
      .catch((error) => {
        // Reject the promise is required to trigger error on response
        return Promise.reject(error.response.data.message)
      })
  },

  addToCart({ commit, dispatch, getters }, cart) {
    commit('UPDATE_CART', cart)
    return true
  },
  updateCart({ state, commit, rootState }) {
    if (state.cart) {
      // Find associated product from list
      const product = _.find(
        rootState.referrer.products,
        (product) => product.code === state.cart.code
      )
      if (!product) {
        commit('UPDATE_CART', null)
      }
    }
  },
  clearCart({ state, commit, rootState }) {
    if (state.cart) {
      commit('UPDATE_CART', null)
    }
  },
  setBadCart({ commit, dispatch }, validCart) {
    commit('VALID_CART', validCart)
  },
}
